<template>
    <div class="c-o-section-request-puff">
        <div class="c-o-section-request-puff__content">
            <h1 v-if="title" class="c-o-section-request-puff__title" v-html="title"></h1>
            <div v-if="body" class="c-o-section-request-puff__body" v-html="body"></div>
            <div class="c-o-section-request-puff__form">
                <drilldown
                    class="c-a-drilldown--vertically-compact"
                    :items="categories"
                    :label="'Välj en kategori för att komma igång'"
                    :placeholder="'Sök efter en kategori'"
                    v-model="category"
                ></drilldown>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FETCH_FILTERS, GET_CATEGORIES, IS_LOADING, GET_ERROR } from '../../../../store/store-models/filters-model';

    import Drilldown from '../../atoms/form/AtomDrilldownCategories.vue'
    import ButtonLink from '../../atoms/AtomButtonLink.vue';
    import Icon from '../../atoms/AtomIcon.vue';

    export default {
        async asyncData ({ store, route }) {
            return store.dispatch(FETCH_FILTERS);
        },
        props:['content', 
                'data', 
                'iframe',
                'extId'
        ],
        components: {
            ButtonLink,
            Drilldown,
            Icon
        },
        data() {
            return {
                chosenCategory: null,
                title: this.content.title,
                body: this.content.body
            }
        },
        computed: {
            ...mapGetters({
                categories: GET_CATEGORIES,
                isLoading: IS_LOADING,
                error: GET_ERROR
            }),
            category: {
                get() {
                    this.chosenCategory;
                },
                set (val) {
                    this.setCategory(val);
                }
            }
        },
        methods: {
            ...mapActions({
                fetchFilters: FETCH_FILTERS,
            }),
            setCategory(value) {
                this.chosenCategory = value;

                if (this.iframe == true) {
                    const externalIdQueryParameter = this.extId ? `?extId=${this.extId}` : '';
                    window.open(`${window.location.origin}/skapa-forfragan/${value.Id}` + externalIdQueryParameter, '_blank');
                } else {
                    this.$router.push({path: `/skapa-forfragan/${value.id}/`})
                }                
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionRequestPuff.vue